import { render, staticRenderFns } from "./PromotionsMain.vue?vue&type=template&id=cc161ec2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports